module.exports = __webpack_public_path__ + "static/shopify-d348c8ea8bdc22bec86fb29913b1afe2.png";